import { AddRounded, EditRounded } from '@mui/icons-material';
import {
    Box,
    Card,
    CardContent,
    Fab,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import { capitalCase } from 'change-case';
import moment from 'moment/moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Iconify from '../../components/fragments/Iconify';
import Screen from '../../components/fragments/Screen';
import { rtGetListData } from '../../store/slices/listSlice';

export default function MyChildrenScreen() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((st) => st);

    const { children, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('user/children', 'children'));
    }, [dispatch]);

    return (
        <Screen loading={busy['children']} title={'My Children'}>
            {children.map((child) => (
                <Child key={child.id} child={child} />
            ))}
            <Fab
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                onClick={() => navigate('/add/children')}
            >
                <AddRounded />
            </Fab>
        </Screen>
    );
}

const Child = ({ child }) => {
    const navigate = useNavigate();

    const {
        id,
        firstName,
        surname,
        gender,
        date_of_birth,
        education,
        status: { disability, confirmed, baptised, occupation } = {},
    } = child;

    return (
        <Grid item xs={12}>
            <Card variant="outlined">
                <CardContent>
                    <Box className="d-flex justify-content-between">
                        <Box>
                            <Typography>
                                {firstName} {surname}
                            </Typography>
                            <Typography variant="body2">
                                {occupation}
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={() => navigate(`/children/${id}`)}
                            color="primary"
                        >
                            <EditRounded />
                        </IconButton>
                    </Box>
                    <Box sx={{ mt: 2 }} className="d-flex">
                        <ListInfoItem
                            label={gender}
                            icon="ph:gender-intersex"
                        />
                        <ListInfoItem
                            label={moment(date_of_birth).format('DD MMM YYYY')}
                            icon="cil:birthday-cake"
                        />
                    </Box>
                    <Box className="d-flex">
                        <ListInfoItem
                            label={capitalCase(education || '')}
                            icon="icon-park-outline:school"
                        />
                        <ListInfoItem
                            label={
                                disability == 'yes'
                                    ? 'Disabled'
                                    : 'Not Disabled'
                            }
                            icon="fontisto:paralysis-disability"
                        />
                    </Box>
                    <Box className="d-flex">
                        <ListInfoItem
                            label={
                                baptised == 'yes' ? 'Baptised' : 'Not Baptised'
                            }
                            icon="akar-icons:water"
                        />
                        <ListInfoItem
                            label={
                                confirmed == 'yes'
                                    ? 'Confirmed'
                                    : 'Not Confirmed'
                            }
                            icon="line-md:confirm-circle"
                        />
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
};

const ListInfoItem = ({ label, icon }) => (
    <Box
        sx={{ width: (window.innerWidth - 68) / 2, my: 0.5 }}
        className="d-flex align-items-center justify-content-start"
    >
        <Iconify style={{ width: 24, height: 24 }} icon={icon} />
        <Typography variant="body2" sx={{ ml: 1 }}>
            {label}
        </Typography>
    </Box>
);
